import Swiper from 'swiper';
import { Navigation, Controller, EffectFade } from 'swiper/modules';

export default {
	init() {
		var layouts = document.querySelectorAll('.layout.video-testimonials');
		if (!layouts.length) return;

		layouts.forEach(function(layout) {
			// The PHP layout only emits .swiper (and the nav buttons) when the
			// repeater has more than one row, so a single-testimonial instance
			// simply has nothing to match here and is left as static markup.
			var mediaEl = layout.querySelector('.video-testimonials-slider.swiper');
			var textEl  = layout.querySelector('.video-testimonials-text-slider.swiper');
			if (!mediaEl && !textEl) return;

			// Second guard: never initialise a one-slide swiper even if the markup
			// says .swiper — a stale cache or hand-edited template shouldn't
			// produce a slider with dead arrows.
			var slideCount = (mediaEl || textEl).querySelectorAll('.swiper-slide').length;
			if (slideCount < 2) return;

			var prevEl = layout.querySelector('.video-testimonials-prev');
			var nextEl = layout.querySelector('.video-testimonials-next');
			var hasNav = !!(prevEl && nextEl);

			// Navigation lives on the media swiper when present, otherwise the text
			// swiper — the controller keeps the other in sync either way.
			var navOnMedia = !!mediaEl;

			function buildConfig(withNav) {
				var cfg = {
					modules:        [Controller, EffectFade],
					effect:         'fade',
					fadeEffect:     { crossFade: true },
					slidesPerView:  1,
					loop:           false,
					speed:          400,
					allowTouchMove: false,
				};
				if (withNav && hasNav) {
					cfg.modules = [Controller, EffectFade, Navigation];
					cfg.navigation = { prevEl: prevEl, nextEl: nextEl };
				}
				return cfg;
			}

			var textSwiper = null;
			if (textEl) {
				var textCfg = buildConfig(!navOnMedia);
				textCfg.autoHeight = true; // handles variable quote lengths
				textSwiper = new Swiper(textEl, textCfg);
			}

			var mediaSwiper = null;
			if (mediaEl) {
				mediaSwiper = new Swiper(mediaEl, buildConfig(true));
			}

			if (mediaSwiper && textSwiper) {
				mediaSwiper.controller.control = textSwiper;
				textSwiper.controller.control  = mediaSwiper;
			}

			// autoHeight is measured at init, before the theme's webfonts land.
			// Once they do, the quote reflows taller and the cached wrapper height
			// is short — the slider's `overflow: hidden` then crops the bottom of
			// the slide (the attribution). Re-measure after fonts and load.
			var refresh = function() {
				if (mediaSwiper) mediaSwiper.update();
				if (textSwiper) {
					textSwiper.update();
					textSwiper.updateAutoHeight(0);
				}
			};

			if (document.readyState !== 'complete') {
				window.addEventListener('load', refresh, { once: true });
			}
			if (document.fonts && document.fonts.ready) {
				document.fonts.ready.then(refresh);
			}
		});
	},
};
